/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-sys-layer-container-accent-background);
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --padding: 0 1px 0 0;
  position: sticky;
  z-index: 100;
  top: 0;
  width: 100%;
}

[internal-host] {
  grid-auto-columns: var(--grid-auto-columns);
  grid-auto-flow: var(--grid-auto-flow);
  grid-template-columns: var(--grid-template-column);
  border-bottom: var(--border-bottom);
  background: var(--background);
  padding: var(--padding);
  display: grid;
  min-width: fit-content;
}

:host([hidden]) {
  display: block !important;
  opacity: 0 !important;
  height: 0 !important;
  z-index: 0 !important;
}
